import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'

const source = {
  beginDrag (props) {
    return {
      index: props.index,
      listId: props.listId,
      item: props.item
    }
  },

  endDrag (props, monitor) {
    const item = monitor.getItem()
    const dropResult = monitor.getDropResult()

    if (dropResult && dropResult.listId !== item.listId) {
      props.removeItem(item.index)
    }

    props.onDrop && props.onDrop()
  }
}

const target = {
  hover (props, monitor, component) {
    const {index: dragIndex, listId: sourceListId} = monitor.getItem()
    const {index: hoverIndex} = props

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) return

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) * 0.5
    const clientOffset = monitor.getClientOffset()
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    // Only perform the move when the mouse has crossed half of the item's height
    // below 50% for down, above 50% for up

    // drag down
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }

    // drag up
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }

    if (props.listId === sourceListId) {
      props.moveItem(dragIndex, hoverIndex)
      // mutate monitor
      monitor.getItem().index = hoverIndex
    }

    if (props.listId !== sourceListId) {
      console.log(component)
      // props.removeItem(dragIndex)
      // component.addItem(monitor.getItem())
      // component.moveItem()
    }
  }
}

@DropTarget(props => props.itemType, target, connect => ({
  connectDropTarget: connect.dropTarget()
}))
@DragSource(props => props.itemType, source, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))
export default class SortItem extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    itemType: PropTypes.string.isRequired
  }

  render () {
    const {connectDropTarget, children, ...props} = this.props
    return React.cloneElement(React.Children.only(children), {
      ...props,
      ref: instance => {
        connectDropTarget(findDOMNode(instance))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./app/components/SortItem.js